module.exports = __webpack_public_path__ + "media/images/author_icons/corresponding_author-3264fb3882f3471ab28fd7273d921fb8.svg";